export const API_BASE_PATH = {
  ADMIN: '/staff',
  PLUGIN: '/plugin'
}